import api from "./api";
import { errorHandling } from "./error.handling";
import { toDateTimeISOString } from './string.service';

const basePath = `${process.env.REACT_APP_API_SCHEDULE_BASE_URL}/v1`;

async function fetchByType(type, start, end) {
  try {

    let payload = {
      "scheduleTypeId": type,
      "dateScheduleStart": toDateTimeISOString(start ? start : new Date(new Date().setMonth(new Date().getMonth() - 1))),
      "dateScheduleEnd": toDateTimeISOString(end ? end : new Date(new Date().setDate(new Date().getDate() + 1))),
      "pageSize": 25,
      "pageNumber": 1
    }

    console.log("importService.fetchByType")
    console.log(payload)

    let response = await api.post(`${basePath}/ScheduleFile/schedulePeriod`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "importService.fetchByType"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "importService.fetchByType");
    return null;
  }
}


async function fetchDetail(scheduleFileId) {
  try {

    let payload =
    {
      "scheduleFileId": scheduleFileId,
      "pageSize": 10,
      "pageNumber": 1
    }


    let response = await api.post(`${basePath}/ScheduleFile/scheduleValidation`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "importService.fetchDetail"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "importService.fetchDetail");
    return null;
  }
}
async function upload(payload) {
  try {

    let response = await api.post(`${basePath}/ScheduleFile/upload`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "importService.upload"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "importService.upload");
    return null;
  }
}

async function DownloadFile(scheduleId, fileName) {
  var url = `${basePath}/ScheduleFile/downloadFile?scheduleFileId=${scheduleId}`;
  return new Promise((resolve, reject) => {
    api.get(url, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
      },
      crossDomain: true,
    })
      .then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        if (!fileName)
          fileName = "teste.txt";

        link.href = url;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);

        link.click();

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const importService = {
  fetchByType,
  upload,
  DownloadFile,
  fetchDetail
};
